import { INotificationModule } from "../notification-service.types";
import { accountProductsRecoveryNotification } from "./account-products-recovery-notification";
import { emailVerificationNotification } from "./email-verification-notification";
import { emailVerificationRerouteNotification } from "./email-verification-reroute-notification";
import { maintenanceBlockerNotification } from "./maintenance-blocker-notification";
import { noAccessSubscriptionNotification } from "./no-access-subscription-notification";
import { pendingInvitesNotification } from "./pending-invites-notification";
import { pinSetupRequiredNotification } from "./pin-setup-required-notification";
import { serviceOutageBlockerNotification } from "./service-outage-blocker-notification";
import { updateRequiredNotification } from "./update-required-notification";
import { userRecordRecoveryNotification } from "./user-record-recovery-notification";
import { welcomeWizardNotification } from "./welcome-wizard-notification";

// Place notifications here in order of priority. Lower index = higher priority.
export const notificationModules: INotificationModule[] = [
  updateRequiredNotification,
  maintenanceBlockerNotification,
  serviceOutageBlockerNotification,
  emailVerificationNotification,
  emailVerificationRerouteNotification,
  userRecordRecoveryNotification,
  pendingInvitesNotification,
  noAccessSubscriptionNotification,
  accountProductsRecoveryNotification,
  welcomeWizardNotification,
  pinSetupRequiredNotification,
];
